(ns app.pusher
  (:require ["pusher-js" :as pusher]
            [clojure.string :refer [includes?]]))


(def  pusher-var (pusher. "c9822d0bade0fef4d7c8"  #js {:cluster "ap2" :encrypted false}))

(defn update-workspace-name-event [workspace-id update-folders]
  (let [workspace-channel (.subscribe pusher-var (str "selected-workspace-" workspace-id))]
    (.bind workspace-channel "update-workspace-name" update-folders)))


(defn update-folder-event [workspace-id update-folders]
  (let [workspace-channel (.subscribe pusher-var (str "selected-workspace-" workspace-id))]
    (.bind workspace-channel "update-folder-name" update-folders)))

(defn unsubscribe-workspace [workspace-id]
  (.unsubscribe pusher-var (str "selected-workspace-" workspace-id)))


(defn unsubscribe-folder [folder-id]
  (.unsubscribe pusher-var (str "selected-folder-" folder-id)))


(defn subscribe-folders [workspace-id update-folders]
  (let [folders-channel (.subscribe pusher-var (str "selected-workspace-" workspace-id))]
    (.bind folders-channel "update-folders-name" update-folders)))

(defn delete-folder [workspace-id update-folders]
  (let [delete-folder-channel (.subscribe pusher-var (str "selected-workspace-" workspace-id))]
    (.bind delete-folder-channel "delete-folder" update-folders)))

(defn create-folder [workspace-id update-folders]
  (let [create-folder-channel (.subscribe pusher-var (str "selected-workspace-" workspace-id))]
    (.bind create-folder-channel "create-folder" update-folders)))

(defn update-form-event [folder-id update-form]
  (let [folder-channel (.subscribe pusher-var (str "selected-folder-" folder-id))]
    (.bind folder-channel "update-form-name" update-form)))

(defn update-product-event [folder-id update-form]
  (let [folder-channel (.subscribe pusher-var (str "selected-folder-" folder-id))]
    (.bind folder-channel "update-product-name" update-form)))

(defn restore-folder [workspace-id update-folders]
  (let [restore-folder-channel (.subscribe pusher-var (str "selected-workspace-" workspace-id))]
    (.bind restore-folder-channel "restore-folder" update-folders)))

(defn move-form-event [folder-id form-id]
  (let [folder-channel (.subscribe pusher-var (str "selected-folder-" folder-id))]
    (.bind folder-channel "move-form" form-id)))

(defn move-product-event [folder-id product-id]
  (let [folder-channel (.subscribe pusher-var (str "selected-folder-" folder-id))]
    (.bind folder-channel "move-product" product-id)))

(defn delete-form-event [folder-id form-id]
  (let [folder-channel (.subscribe pusher-var (str "selected-folder-" folder-id))]
    (.bind folder-channel "delete-form" form-id)))

(defn delete-product-event [folder-id product-id]
  (let [folder-channel (.subscribe pusher-var (str "selected-folder-" folder-id))]
    (.bind folder-channel "delete-product" product-id)))

(defn duplicate-form-event [folder-id form-id]
  (let [folder-channel (.subscribe pusher-var (str "selected-folder-" folder-id))]
    (.bind folder-channel "duplicate-form" form-id)))

(defn duplicate-product-event [folder-id product-id]
  (let [folder-channel (.subscribe pusher-var (str "selected-folder-" folder-id))]
    (.bind folder-channel "duplicate-product" product-id)))

(defn copy-form-event [folder-id form-id]
  (let [folder-channel (.subscribe pusher-var (str "selected-folder-" folder-id))]
    (.bind folder-channel "copy-form" form-id)))

(defn copy-product-event [folder-id product-id]
  (let [folder-channel (.subscribe pusher-var (str "selected-folder-" folder-id))]
    (.bind folder-channel "copy-product" product-id)))

(defn empty-trash-event [workspace-id update-folders]
  (let [empty-trash-channel (.subscribe pusher-var (str "selected-workspace-" workspace-id))]
    (.bind empty-trash-channel "empty-trash" update-folders)))

(defn restore-to-workspace [workspace-id update-folders]
  (let [restore-folder-channel (.subscribe pusher-var (str "selected-workspace-" workspace-id))]
    (.bind restore-folder-channel "restore-to-workspace" update-folders)))


(defn move-multiple-event [folder-id update-folder]
  (let [folder-channel (.subscribe pusher-var (str "selected-folder-" folder-id))]
    (.bind folder-channel "move-multiple" update-folder)))

(defn copy-multiple-event [folder-id update-folder]
  (let [folder-channel (.subscribe pusher-var (str "selected-folder-" folder-id))]
    (.bind folder-channel "copy-multiple" update-folder)))

(defn undo-delete-event [folder-id update-folder]
  (let [folder-channel (.subscribe pusher-var (str "selected-folder-" folder-id))]
    (.bind folder-channel "undo-delete" update-folder)))

(defn delete-multiple-event [folder-id update-folder]
  (let [folder-channel (.subscribe pusher-var (str "selected-folder-" folder-id))] 
    (.bind folder-channel "delete-multiple" update-folder)))